import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/img/logo/logo_simple.png'


const _hoisted_1 = {
  ref: "root",
  class: "call2 topPage"
}
const _hoisted_2 = { class: "slider-outer" }
const _hoisted_3 = { class: "slider-inner" }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  id: "app",
  class: "contact"
}
const _hoisted_6 = {
  class: "contact-form",
  method: "post",
  action: ""
}
const _hoisted_7 = { class: "error" }
const _hoisted_8 = { class: "error" }
const _hoisted_9 = { class: "error" }
const _hoisted_10 = { class: "error" }
const _hoisted_11 = {
  key: 0,
  class: "error"
}
const _hoisted_12 = { class: "error" }
const _hoisted_13 = { class: "mt12" }
const _hoisted_14 = { class: "error" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = {
  key: 0,
  class: "contact-result"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FullCalendar = _resolveComponent("FullCalendar")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.slides, (slide, idx) => {
          return (_openBlock(), _createElementBlock("img", {
            key: idx,
            class: _normalizeClass([_ctx.state.current_slide == idx ? 'active' : '', "slide-img"]),
            src: _ctx.state.slides[0].img
          }, null, 10, _hoisted_4))
        }), 128))
      ]),
      _cache[7] || (_cache[7] = _createElementVNode("div", { class: "over-ray" }, [
        _createElementVNode("div", { class: "top-inner" }, [
          _createElementVNode("div", { class: "top-items-title" }, [
            _createElementVNode("h2", null, "Contact"),
            _createElementVNode("p", null, "問い合わせ")
          ])
        ])
      ], -1))
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("form", _hoisted_6, [
        _createElementVNode("table", null, [
          _createElementVNode("tbody", null, [
            _createElementVNode("tr", null, [
              _cache[8] || (_cache[8] = _createElementVNode("th", null, [
                _createTextVNode("お名前"),
                _createElementVNode("br"),
                _createElementVNode("span", { class: "tag" }, "必須")
              ], -1)),
              _createElementVNode("td", null, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.name) = $event)),
                  placeholder: "例）宮元 啓介"
                }, null, 512), [
                  [_vModelText, _ctx.state.name]
                ]),
                _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.errors.name), 1)
              ])
            ]),
            _createElementVNode("tr", null, [
              _cache[9] || (_cache[9] = _createElementVNode("th", null, [
                _createTextVNode("フリガナ"),
                _createElementVNode("br"),
                _createElementVNode("span", { class: "tag" }, "必須")
              ], -1)),
              _createElementVNode("td", null, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.kana) = $event)),
                  placeholder: "例）ミヤモト ケイスケ"
                }, null, 512), [
                  [_vModelText, _ctx.state.kana]
                ]),
                _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.errors.kana), 1)
              ])
            ]),
            _createElementVNode("tr", null, [
              _cache[10] || (_cache[10] = _createElementVNode("th", null, [
                _createTextVNode("電話番号"),
                _createElementVNode("br"),
                _createElementVNode("span", { class: "tag" }, "必須")
              ], -1)),
              _createElementVNode("td", null, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.tel) = $event)),
                  placeholder: "例）03-5672-9860"
                }, null, 512), [
                  [_vModelText, _ctx.state.tel]
                ]),
                _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.errors.tel), 1)
              ])
            ]),
            _createElementVNode("tr", null, [
              _cache[11] || (_cache[11] = _createElementVNode("th", null, [
                _createTextVNode("メールアドレス"),
                _createElementVNode("br"),
                _createElementVNode("span", { class: "tag" }, "必須")
              ], -1)),
              _createElementVNode("td", null, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.email) = $event)),
                  placeholder: "例）k.m.cyclone1216@gmail.com"
                }, null, 512), [
                  [_vModelText, _ctx.state.email]
                ]),
                _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.errors.email), 1)
              ])
            ]),
            _createElementVNode("tr", null, [
              _cache[13] || (_cache[13] = _createElementVNode("th", null, [
                _createTextVNode("お問い合わせ項目"),
                _createElementVNode("br"),
                _createElementVNode("span", { class: "tag" }, "必須")
              ], -1)),
              _createElementVNode("td", null, [
                _withDirectives(_createElementVNode("select", {
                  name: "time",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.contentstype) = $event))
                }, _cache[12] || (_cache[12] = [
                  _createStaticVNode("<option value=\"\" data-v-0caa6925>選択してください</option><option value=\"体験-フリータイム枠\" data-v-0caa6925>体験-フリータイム枠</option><option value=\"体験-キック初級クラス\" data-v-0caa6925>体験-キック初級クラス</option><option value=\"体験-エントリーキッククラス\" data-v-0caa6925>体験-エントリーキッククラス</option><option value=\"体験-レディースエントリークラス\" data-v-0caa6925>体験-レディースエントリークラス</option><option value=\"体験-レディースキッククラス\" data-v-0caa6925>体験-レディースキッククラス</option><option value=\"体験-学生クラス\" data-v-0caa6925>体験-学生クラス</option><option value=\"見学希望\" data-v-0caa6925>見学希望</option><option value=\"その他\" data-v-0caa6925>その他</option>", 9)
                ]), 512), [
                  [_vModelSelect, _ctx.state.contentstype]
                ]),
                (_ctx.state.contentstype === '体験-学生クラス')
                  ? (_openBlock(), _createElementBlock("p", _hoisted_11, "対象：小学校1年生〜中学校3年生"))
                  : _createCommentVNode("", true),
                _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.errors.contentstype), 1)
              ])
            ]),
            _createElementVNode("tr", null, [
              _cache[14] || (_cache[14] = _createElementVNode("th", null, [
                _createTextVNode("ご希望の日付 "),
                _createElementVNode("p", { class: "calendar-text" }, "※お問い合わせ項目を選択すると選択可能日が表示されます。"),
                _createElementVNode("p", { class: "error2" }, [
                  _createTextVNode("当日、翌日の体験予約は出来ません。"),
                  _createElementVNode("br"),
                  _createTextVNode("2日後の予約が可能となります。")
                ])
              ], -1)),
              _createElementVNode("td", null, [
                _withDirectives(_createVNode(_component_FullCalendar, {
                  class: "fullcalendarContent fullcalendarMain",
                  ref: "fullcalendarMain",
                  options: _ctx.calendarOptions
                }, null, 8, ["options"]), [
                  [_directive_click_outside, () => { }]
                ]),
                _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.state.date) + " " + _toDisplayString(_ctx.state.datetime), 1)
              ])
            ]),
            _createElementVNode("tr", null, [
              _cache[15] || (_cache[15] = _createElementVNode("th", null, "お問合せ内容", -1)),
              _createElementVNode("td", null, [
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.contents) = $event)),
                  name: "contents",
                  cols: "30",
                  rows: "3"
                }, null, 512), [
                  [_vModelText, _ctx.state.contents]
                ]),
                _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.errors.contents), 1)
              ])
            ])
          ])
        ]),
        (!_ctx.valid)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              disabled: !_ctx.valid,
              type: "button"
            }, "未入力の必須項目があります", 8, _hoisted_15))
          : (_ctx.valid)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                type: "button",
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
              }, "送信"))
            : _createCommentVNode("", true)
      ]),
      _createVNode(_Transition, { name: "fade" }, {
        default: _withCtx(() => [
          (_ctx.state.result)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(_ctx.state.result), 1))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _cache[16] || (_cache[16] = _createElementVNode("div", { class: "contact-bg" }, [
        _createElementVNode("img", { src: _imports_0 })
      ], -1)),
      _cache[17] || (_cache[17] = _createElementVNode("div", { class: "contact-bg2" }, [
        _createTextVNode(" TAKE A"),
        _createElementVNode("br"),
        _createTextVNode("      BREATH ")
      ], -1))
    ])
  ], 512))
}